import { render } from "./TableOfContents.vue?vue&type=template&id=808594e0&scoped=true&ts=true"
import script from "./TableOfContents.vue?vue&type=script&lang=ts"
export * from "./TableOfContents.vue?vue&type=script&lang=ts"

import "./TableOfContents.vue?vue&type=style&index=0&id=808594e0&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/range-compose-campaign-ui_master/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-808594e0"]])

export default __exports__